export default __webpack_public_path__ + "static/media/refresh.70b7224e.svg";